// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"121":"vendor","792":"main"}[chunkId] || chunkId) + "." + {"121":"dd2e94c05c8afc7f651e","792":"580cc09d801a310b1808","908":"07773d41894a3f7bf328"}[chunkId] + ".bundle.js";
};